document.addEventListener("DOMContentLoaded", (e) => {
	const productEnquireBtn = document.querySelector(".js-product-enquire-btn");

	if (productEnquireBtn) {
		productEnquireBtn.addEventListener("click", (e) => {
			e.preventDefault();
			
			// Get the href attribute
			const href = productEnquireBtn.getAttribute("href");
			console.log("href", href);

			// Get the product name
			const productName = productEnquireBtn.getAttribute("data-product_name");
			console.log("productName", productName);

			// Send the user to the button URL with the product name appended
			const redirectUrl = `${href}/?product_name=` + convertStringToSlug(productName);
			console.log("redirectUrl", redirectUrl);

			// Redirect to the new URL
			window.location.href = redirectUrl;
		});
	}

	// Once we are at the product enquiry page, pass the product name into the hidden Gravity Forms field
	if (window.location.contains("?product_name=")) {
		console.log("True");
	}

	function convertStringToSlug(text) {
		return text.toLowerCase()
			.replace(/ /g, "-")
			.replace(/[^\w-]+/g, "");
	}
});
